import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {CarePlanService} from "../care-plan-service.model";

export class CarePlanServiceDgSerachResults extends GenericDgSearchResults {
  public results: CarePlanService[];

  constructor(total: number, results: CarePlanService[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

